import { render, staticRenderFns } from "./AvatarStyleText.vue?vue&type=template&id=a34dc296&scoped=true"
import script from "./AvatarStyleText.vue?vue&type=script&lang=js"
export * from "./AvatarStyleText.vue?vue&type=script&lang=js"
import style0 from "./AvatarStyleText.vue?vue&type=style&index=0&id=a34dc296&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34dc296",
  null
  
)

export default component.exports